/* eslint-disable */
import React, { useMemo } from 'react';
import { CTitle, TTitle } from '../../components/Widget';
import { useParams } from 'react-router-dom';
import ToolsBox from '../../components/ToolsBox';
import ToolsTop from '../../../../../../assets/cybersecurity2026/topic1600/tools-top.png';
import ToolsBottom from '../../../../../../assets/cybersecurity2026/topic1600/tools-bottom.png';
import { useUpdateComponentState } from '../../../hooks';
interface ISection0Props {
  settings: any;
}

const Section3: React.FunctionComponent<ISection0Props> = ({ settings }) => {
  const ID = '4';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[3],
    [settings?.paragraphs]
  );
  const updateComponentState = useUpdateComponentState();

  const handleComplete = React.useCallback(() => {
    updateComponentState(
      p_course,
      p_topic,
      ID,
      'cybersecurity2026-topic1600-section3-1'
    );
  }, [updateComponentState, p_course, p_topic, ID]);

  return (
    <div className="topic-section-3">
      <CTitle title={paragraphsSettings?.title} />
      <ToolsBox
        leftText={paragraphsSettings?.l3}
        rightText={paragraphsSettings?.l4}
        leftBackgroundImage={ToolsTop}
        rightBackgroundImage={ToolsBottom}
        id="cybersecurity2026-topic1600-section3-1"
        onComplete={handleComplete}
      />
      <TTitle title={paragraphsSettings?.guideTips} />
      <div className="guide">
        <div className="guide-content">
          {paragraphsSettings?.guideList.map((item: any, index: number) => (
            <div key={index} className={`guide-item guide-item-${index + 1}`}>
              <div className="guide-item-title">{item?.title}</div>
              <div className="guide-item-content">{item?.desc}</div>
            </div>
          ))}
          {paragraphsSettings?.guideContent}
        </div>
      </div>
    </div>
  );
};

export default React.memo(Section3);
